var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portal',{attrs:{"to":"popup"}},[_c('PopupBase',{attrs:{"label":_vm.label},on:{"close":function($event){return _vm.$router.back()}}},[_vm._t("backdrop",null,{"slot":"backdrop"}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }